import { DateTime } from 'luxon';
import { InsuranceDocument } from './customer-customer';
import { UserDocument } from '../../quipli-service/user/user';

export namespace CustomerParsers {
  export type CustomerInsuranceJson = {
    id?: number;
    userId: number;
    firstName?: string;
    lastName?: string;
    issuedBy?: string;
    policyNumber?: string;
    expiryDate?: string;
    issuedDate?: string;
    coverageAmount?: number;
    fileId?: number;
    createdAt?: string;
    updatedAt?: string;
    file?: UserDocument;
  };

  export function toCustomerInsurance(input: CustomerInsuranceJson): InsuranceDocument {
    return {
      id: input.id,
      userId: input.userId,
      firstName: input.firstName,
      lastName: input.lastName,
      issuedBy: input.issuedBy,
      policyNumber: input.policyNumber,
      expiryDate: input.expiryDate ? DateTime.fromFormat(input.expiryDate, 'yyyy-MM-dd') : undefined,
      issuedDate: input.issuedDate ? DateTime.fromFormat(input.issuedDate, 'yyyy-MM-dd') : undefined,
      coverageAmount: input.coverageAmount,
      createdAt: input.createdAt ? DateTime.fromISO(input.createdAt, { setZone: true }) : undefined,
      updatedAt: input.updatedAt ? DateTime.fromISO(input.updatedAt, { setZone: true }) : undefined,
      file: input.file,
    };
  }
}
